import React from "react";
import {Col, Row} from "antd";
import { template, setLocalStorage } from "@reco-m/core";
import { ViewComponent, Banner, ImageAuto } from "@reco-w/core-ui";
import { Namespaces, scientificModel } from "@reco-w/scientific-models";
import { BackTopBox } from "@reco-w/about-e";

export namespace Scientific {

    export interface IProps<S extends IState = IState> extends ViewComponent.IProps<S> {}

    export interface IState extends ViewComponent.IState, scientificModel.StateType {}

    export class Component<P extends IProps = IProps, S extends IState = IState> extends ViewComponent.Base<P, S> {
        showloading = false;
        namespace = Namespaces.scientific;

        componentMount() {
            window.scroll(0, 0);
            setLocalStorage("selectedMenu", `/scientific`);
        }
        componentDidMount() {
            this.dispatch("input", {scientificIndex: 0})
        }



        renderService() {
            return (
                <div className="block-content company-content">
                    <div className="container">
                        <div className="second-title">
                            <span>了解科创</span>
                        </div>
                        <div className="company-info">
                            瑞谷科创 RECO SPACE 成立于2015年，是行业领先的大企业开放创新中心产业运营商。瑞谷科创RECO SPACE聚焦数字经济赛道，建立“大中小融通协同创新机制”。帮助地方政府/园区引入大型头部企业，落地大企业开放创新中心，并开展招商运营，提供持续孵化加速服务，帮助地方政府搭建大中小融通的产业功能性平台。
                        </div>
                    </div>
                </div>
            )
        }

        renderKcservice() {
            const fwData = [
                {
                    title: "大企业开放创新中心",
                    img: "assets/images/guanw/kc-img2.jpg",
                    desc: <>
                        <p>产业龙头企业参与共建的开放创新中心，在指定产业赛道上开展初创孵化和产业加速服务运营。</p>
                    </>
                },
                {
                    title: "科创载体委托运营",
                    img: "assets/images/guanw/kc-img1.jpg",
                    desc: <>
                        <p>瑞谷科创Reco Space品牌运营，开展科技创新初创企业孵化、（科小、高企、专精特新、瞪羚）梯度培育、科技项目产业化导入、人才项目导入等业务。</p>
                    </>
                },
                {
                    title: "域外产创基地运营",
                    img: "assets/images/guanw/kc-img3.jpg",
                    desc: <>
                        <p>全国各地政府和园区在异地的飞地运营，科创研发在飞地、生产服务在本地。</p>
                    </>
                },
                {
                    title: "双招双引人才基地运营",
                    img: "assets/images/guanw/kc-img4.jpg",
                    desc: <>
                        <p>国内/海外人才项目目的地、高技能大师工作室落地、产教融合基地。开展人才项目招引、人才实训、创新培育、投融对接、产业上下游对接、政策落地等业务。</p>
                    </>
                },
                {
                    title: "品牌影响力打造",
                    img: "assets/images/guanw/kc-img5.jpg",
                    desc: <>
                        <p>通过为政府/园区/企业打造一系列品牌IP活动，提高品牌影响力，打造产业生态，营造良好的创新创业氛围。</p>
                    </>
                },
            ]
            return (
                <div className="block-content scientific-content">
                    <div className="container">
                        <div className="second-title">
                            <span>科创服务</span>
                        </div>
                    </div>
                    <Row gutter={[1,1]} className="scientific-row">
                        {
                            fwData.map((item, i) => {
                                return (
                                    <Col  xs={24} sm={24} md={5} xl={5} key={i}>
                                        <div className="kc-item">
                                            <img src={item.img} width="100%" height="600px" />
                                            <div className="kc-item-write">
                                                <div className="kc-item-index">{"0" + (i+1)}</div>
                                                <div className="kc-item-title">{item.title}</div>
                                                <div className="kc-item-desc">{item.desc}</div>
                                            </div>
                                        </div>
                                    </Col>
                                )
                            })
                        }
                    </Row>
                </div>
            )
        }

        renderKchistory() {
            const historyData = [
                {
                    date: "2015.12",
                    title: <>瑞谷科创与阿里云合作的首个创新中心落户上海松江</>,
                    imgUrl: "assets/images/second/lc-img1.jpg",
                    position: "right"
                },
                {
                    date: "2016.03",
                    title: <>阿里云创新中心华东旗舰项目<br />上海张江基地签约</>,
                    imgUrl: "assets/images/second/lc-img2.jpg",
                    position: "left"
                },
                {
                    date: "2017.08",
                    title: <>瑞谷科创自主打造的上海嘉定<br />创新基地上线</>,
                    imgUrl: "assets/images/second/lc-img3.jpg",
                    position: "right"
                },
                {
                    date: "2018.04",
                    title: <>阿里云创新中心-天津基地<br />正式落户津南</>,
                    imgUrl: "assets/images/second/lc-img4.jpg",
                    position: "left"
                },
                {
                    date: "2019.11",
                    title: <>阿里云创新中心-上海临港基地<br />隆重开业</>,
                    imgUrl: "assets/images/second/lc-img5.jpg",
                    position: "right"
                },
                {
                    date: "2020.07",
                    title: <>宝马初创车库-阿里云创新中心<br />上海金桥基地签约</>,
                    imgUrl: "assets/images/second/lc-img6.jpg",
                    position: "left"
                },
                {
                    date: "2021.06",
                    title: <>阿里云创新中心-丽水基地<br />于遂昌正式开业</>,
                    imgUrl: "assets/images/second/lc-img7.jpg",
                    position: "right"
                },
                {
                    date: "2021.07",
                    title: <>杭州首个蚂蚁链产业创新中心<br />正式落户西溪</>,
                    imgUrl: "assets/images/second/lc-img8.jpg",
                    position: "left"
                },
                {
                    date: "2022.01",
                    title: <>上海市北蚂蚁链产业创新中心<br />成功签约</>,
                    imgUrl: "assets/images/second/lc-img9.jpg",
                    position: "right"
                },
                {
                    date: "2022.03",
                    title: <>浙江丽水蚂蚁链产业创新中心<br />在莲都正式揭牌</>,
                    imgUrl: "assets/images/second/lc-img10.jpg",
                    position: "left"
                },
                {
                    date: "2022.08",
                    title: <>宝马初创车库-阿里云联合创新基地<br />落地成都高新区</>,
                    imgUrl: "assets/images/second/lc-img11.jpg",
                    position: "right"
                },
                {
                    date: "2023.09",
                    title: <>盐城亭湖青年创业人才栖息地<br />8#新生·数字科技创新园开园</>,
                    imgUrl: "assets/images/second/lc-img12.jpg",
                    position: "left"
                }
            ]
            return (
                <div className="block-content history-content">
                    <div className="container">
                        <div className="second-title">
                            <span>科创基地</span>
                        </div>
                        <div className="history-list">
                            {
                                historyData.map((item, i) => {
                                    return (
                                        <Row key={i} className={"history-item " + item.position}>
                                            <div className="history-item-ring" />
                                            <div className="history-item-img"><ImageAuto.Component src={item.imgUrl} width="100%" height="100%" radius={0} /></div>
                                            <div className="history-item-content">
                                                <div className="size-24 primary-color history-item-date">{item.date}</div>
                                                <div className="size-18 gray-one-color mt5 history-item-title">{item.title}</div>
                                            </div>
                                        </Row>
                                    )
                                })
                            }
                        </div>
                    </div>
                </div>
            )
        }

        renderBody() {
            return (
                <>
                    <div className="content">
                        <Banner.Component extraClass="large" bimg="assets/images/guanw/rgkc-banner.jpg" cimg="" text={
                            <div className="home-banner-text">
                                <div className="banner-text-name1">瑞谷科创</div>
                                <div className="banner-text-name2 mt25">
                                    大企业开放创新中心产业运营商
                                </div>
                            </div>}
                        />
                        {this.renderService()}
                        {this.renderKcservice()}
                        {this.renderKchistory()}


                        {this.renderEmbeddedView(BackTopBox.Page)}
                    </div>
                </>
            );
        }
    }

    export const Page = template(Component, (state) => state[Namespaces.scientific]);
}
